export enum ChatFilterTypeEnum {
  None = 0,
  Unread = 1,
  Starred = 2,
  All = 3,
  My = 4,
}
